import i18nMain from './vi/i18nMain';
import i18nValidate from './vi/i18nValidate';
import i18nComponent from './vi/i18nComponent';
import i18nEnum from './vi/i18nEnum';
import i18nCommon from './vi/i18nCommon';
import i18nBaseForm from './vi/i18nBaseForm';
import i18nNumber from './vi/i18nNumber';
import i18nMonitor from './vi/monitor/i18nMonitor';
import i18nHelpLink from './vi/i18nHelpLink';
import i18nPages from './vi/i18nPages';
import i18nDataManagement from './vi/views/system/i18nDataManagement';
import i18nClosingLedger from './vi/views/system/i18nClosingLedger';
import i18nSearchVoucher from './vi/views/system/i18nSearchVoucher';
import i18nQuickReport from './vi/views/system/i18nQuickReport';
import i18nRole from './vi/views/system/i18nRole';
//#region Danh mục
import i18nDIAccountTransfer from './vi/views/dictionary/i18nDIAccountTransfer';
import i18nDIDefaultAccount from './vi/views/dictionary/i18nDIDefaultAccount';
import i18nDIAsset from './vi/views/dictionary/i18nDIAsset';
import i18nDIBankStandard from './vi/views/dictionary/i18nDIBankStandard';
import i18nDIAccountCategory from './vi/views/dictionary/i18nDIAccountCategory';
import i18nDIAssetCategory from './vi/views/dictionary/i18nDIAssetCategory';
import i18nDIReceipt from './vi/views/dictionary/i18nDIReceipt';
import i18nDIAccountingObject from './vi/views/dictionary/i18nDIAccountingObject';
//#endregion

//#region Séc
import i18nCheque from './vi/views/cheque/i18nCheque';
//#endregion

//#region Phiếu nhập kho
import i18nInwardStock from './vi/views/inwardStock/i18nInwardStock';
//#endregion
// Thiết lập in báo cáo
import i18nPrintReportSetting from './vi/views/dictionary/i18nPrintReportSetting';

//#region Phân phối
import i18nAccountTransferSlipVoucher from './vi/views/distribution/i18nAccountTransferSlipVoucher';
import i18nVoucherList from './vi/views/distribution/i18nVoucherList';
import i18nJusticeReceipt from './vi/views/distribution/i18nJusticeReceipt';
//#endregion

//#region Tiền mặt tại quỹ
import i18nCashReceipt from './vi/views/cash/i18nCashReceipt';
import i18nCashPayment from './vi/views/cash/i18nCashPayment';


//#endregion

//#region nghiệp vụ tài sản/tang vật
import i18nAssetTransfer from './vi/views/asset/i18nAssetTransfer';
import i18nInventory from './vi/views/asset/i18nInventory';
//#endregion

//#region Báo cáo
import i18nReportList from './vi/views/report/i18nReportList';
//#endregion

//#region Sổ cái
import i18nAccountTransferSlip from './vi/views/ledger/i18nAccountTransferSlip';
import i18nOtherVoucher from './vi/views/ledger/i18nOtherVoucher';
//#endregion

//#region Phân hệ tổng hợp toàn ngành
import i18nReceiveSubOrgReport from './vi/views/summary/i18nReceiveSubOrgReport';
//#endregion

import i18nFormatNumber from './vi/views/setup/i18nFormatNumber';

//#region Import Excel
import i18nImportExcel from './vi/views/common/import/i18nImportExcel';
//#endregion

//#region Kho bạc Nhà nước
import i18nDVCFile from './vi/views/etreasury/i18nDVCFile';
//#endregion
export default {
  vi: {
    i18nMain,
    i18nValidate,
    i18nComponent,
    i18nEnum,
    i18nCommon,
    i18nBaseForm,
    i18nNumber,
    i18nMonitor,
    i18nHelpLink,
    i18nPages,
    i18nDataManagement,
    i18nSearchVoucher,
    i18nQuickReport,
    i18nClosingLedger,
    i18nRole,

    //#region Danh mục
    i18nDIAccountTransfer,
    i18nDIDefaultAccount,
    i18nDIAsset,
    i18nDIBankStandard,
    i18nDIAccountCategory,
    i18nDIAssetCategory,
    i18nDIReceipt,
    i18nDIAccountingObject,
    //#endregion

    //#region Phân phối
    i18nAccountTransferSlipVoucher,
    i18nVoucherList,
    i18nJusticeReceipt,
    //#endregion i18nCashReceipt

    //#region Tiền mặt tại quỹ
    i18nCashReceipt,
    i18nCashPayment,
    //#endregion

    //#region nghiệp vụ tài sản/tang vật
    i18nAssetTransfer,
    i18nInventory,
    //#endregion

    //#region Báo cáo
    i18nReportList,
    //#endregion

    //#region Sổ cái
    i18nAccountTransferSlip,
    i18nOtherVoucher,
    //#endregion

    //#region Phân hệ tổng hợp toàn ngành
    i18nReceiveSubOrgReport,
    //#endregion
    i18nFormatNumber,

    // Thiết lập in báo cáo
    i18nPrintReportSetting,

    // Séc
    i18nCheque,

    // Phiếu nhập kho
    i18nInwardStock,

    // Import Excel
    i18nImportExcel,

    // Kho bạc Nhà nước
    i18nDVCFile,
  },
};
